import React from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { setSidebarOpened, sidebarMenuExpanded, sidebarOpened, useStore } from "../../helpers";
const sxStyles = ({ spacing, palette, zIndex, transitions }) => ({
    toggle: {
        position: "fixed",
        left: 0,
        top: "95px",
        transform: `translateX(${spacing(25)})`,
        opacity: 0,
        zIndex: zIndex.drawer,
    },
    toggleStart: {
        opacity: 1,
        transition: transitions.create(["opacity"], {
            duration: transitions.duration.enteringScreen,
            delay: transitions.duration.shortest / 0.5,
        }),
    },
    toggleEnd: {
        opacity: 0,
        transition: transitions.create(["opacity"], {
            duration: transitions.duration.leavingScreen,
            delay: transitions.duration.shortest / 3,
        }),
    },
    toggleIcon: {
        borderRadius: "30px",
        border: `1px solid ${palette.primary.main}`,
        color: palette.primary.main,
        backgroundColor: "white",
        width: "33px",
        height: "33px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        padding: "5px",
        transition: transitions.create(["color", "backgroundColor"]),
        "&:hover": {
            color: "white",
            backgroundColor: palette.primary.light,
            borderColor: palette.primary.light,
        },
    },
    toggleOpened: {
        transform: `rotate(180deg)`,
    },
});
const SidebarToggle = () => {
    const { breakpoints } = useTheme();
    const isLargeScreen = useMediaQuery(breakpoints.up("xl"));
    const isOpened = useStore(sidebarOpened);
    const isExpanded = useStore(sidebarMenuExpanded);
    const handleClick = () => {
        setSidebarOpened(!isOpened);
    };
    if (!isLargeScreen) {
        return null;
    }
    return (React.createElement(Box, { sx: (theme) => ({
            ...sxStyles(theme).toggle,
            ...(isExpanded ? sxStyles(theme).toggleStart : sxStyles(theme).toggleEnd),
        }) },
        React.createElement(ArrowForwardIosIcon, { sx: (theme) => ({
                ...sxStyles(theme).toggleIcon,
                ...(isOpened ? sxStyles(theme).toggleOpened : null),
            }), onClick: handleClick })));
};
export default SidebarToggle;
//# sourceMappingURL=SidebarToggle.js.map